"use client"
import { queryShopingCartNum } from "@/service/carts";
import React, { useEffect } from "react";
import shopCartStore from "@/store/shopCartStore";
import useSWR from "swr";

export default function SetShopCartComponent(props: any) {
  const { setShopCart } = shopCartStore();

  const { data: shopCount } = useSWR(
    "queryShopCartCount",
    async () => await queryShopCartCount(),
    {
      revalidateOnFocus: false, //不需要页面聚焦时自动重新请求数据
      // revalidateIfStale: false,//如果你希望即使页面切换也不要重新请求，只要数据存在缓存
    }
  );

  useEffect(() => {
    setShopCart({ count: shopCount || 0 })
  }, [shopCount])


  /**
   * 查询购物车数量
   * @returns 
   */
  const queryShopCartCount = async () => {
    try {
      const { status, data } = await queryShopingCartNum();
      if (status === 200) {
        return data?.count || 0;  // 返回购物车数量，默认值为0
      }
      return 0;  // 如果状态不是200，返回0
    } catch (error) {
      return 0;  // 如果请求失败，返回0
    }
  }

  return <></>
}

